import { type AggRequest, fetchAgg } from '../../../../common/utils/fetch-agg';

import { operationName, quickFindSearchGraphQuery } from './query';
import { type QuickFindGraphQLSearchQueryType, type QuickFindSearchQueryVariables } from './types';

export type QuickFindSearchQueryProps = Pick<
	AggRequest<QuickFindSearchQueryVariables>,
	'aggAbsoluteUrl' | 'variables' | 'headers'
>;

export const quickFindSearchQuery: ({
	variables,
	aggAbsoluteUrl,
	headers,
}: QuickFindSearchQueryProps) => Promise<
	import('../../../..').AggResponse<QuickFindGraphQLSearchQueryType>
> = ({ variables, aggAbsoluteUrl, headers }: QuickFindSearchQueryProps) => {
	return fetchAgg<QuickFindSearchQueryVariables, QuickFindGraphQLSearchQueryType>({
		variables,
		aggAbsoluteUrl,
		graphQuery: quickFindSearchGraphQuery,
		operationName,
		headers,
	});
};
